<script>
import { mapActions } from 'vuex';
import Catalogue from '@/services/catalogue';
import request from '@/services/request';

export default {
    name: "modal-program-property",

    data() {
        return {
            errors: {},
			catalogue: new Catalogue(),
            form: {
                program_id: "",
                building_id: "",
            },

            assigned_properties: [],
            available_properties: [],
        }
    },

    methods: {
        closeModal() {
            this.errors = {};

            this.form = {
                program_id: "",
                building_id: "",
            };
            this.available_properties = [];

            this.$modal.hide("modalProgramProperty");
        },

        /** FILTRAR PROPIEDADES YA ASIGNADAS */
        filterAvailable() {
            const all = this.catalogue.buildings ?? [];

            this.available_properties = all.filter(p =>
                !this.assigned_properties.includes(p.id)
            );
        },

        /** CREAR RELACIÓN (NO EXISTE EDICIÓN) */
        async saveProperty() {

            let payload = {
                program_id: this.form.program_id,
                building_id: this.form.building_id
            };

            try {
                let { data } = await request.post("/programs_buildings", payload);

                this.successNotification(data.message);

                this.closeModal();

                // Recargar TAB principal
                Event.$emit("event-reload-program-relations");

            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },

        ...mapActions({
            errorNotification: "alert/error",
            successNotification: "alert/success"
        }),
    },

    created() {

        /**
         * EVENTO → SOLO CREAR, SIN EDITAR
         */
        Event.$on("event-open-program-property", async (data) => {
            this.errors = {};

            // propiedades ya asignadas al programa
            this.assigned_properties = data.assigned_properties ?? [];

            // program_id obligatorio
            this.form.program_id = data.program_id;

            // cargar catálogo
            await this.catalogue.get_buildings();

            // evitar repetidos
            this.filterAvailable();

            this.$modal.show("modalProgramProperty");
        });

    }
}
</script>

<template>
    <modal name="modalProgramProperty" :width="'50%'" :height="'auto'" :click-to-close="false">

        <form @submit.prevent="saveProperty">

            <!-- Cerrar -->
            <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closeModal">
                <i class="fa-solid fa-xmark"></i>
            </button>

            <div class="modal-header">
                <h5 class="modal-title">Asignar Propiedad</h5>
            </div>

            <div class="modal-body">
                <div class="row">

                    <!-- SELECT -->
                    <div class="col-md-12">
                        <label>Propiedad</label>
                        <select class="form-control" v-model="form.building_id">
                            <option value="">Seleccione</option>

                            <option v-for="p in available_properties" 
                                    :key="p.id" 
                                    :value="p.id">
                                {{ p.name }}
                            </option>
                        </select>

                        <div class="text-danger" v-if="errors.building_id">
                            {{ errors.building_id[0] }}
                        </div>
                    </div>

                    <!-- BOTONES -->
                    <div class="col-12 mt-4">
                        <hr>

                        <button type="submit" class="btn float-right btn-outline-success">
                            <i class="fas fa-save"></i> Asignar
                        </button>

                        <button type="button" class="btn float-left btn-outline-warning" @click="closeModal">
                            <i class="fas fa-undo-alt"></i> Cancelar
                        </button>
                    </div>

                </div>
            </div>

        </form>

    </modal>
</template>

<style scoped>
.text-danger {
    font-size: 12px;
}
</style>
